import axios from 'axios'
import { baseUrl } from './config'

export function getTransactions (params) {
  return axios.get(`${baseUrl}/transactions`, {
    params
  })
}

export function getTransactionByID (id) {
  return axios.get(`${baseUrl}/transactions/${id}`)
}

export function updateStatus (params) {
  return axios.put(`${baseUrl}/transactions/confirm`, params)
}

export function getConfirmPaymentSystems () {
  return axios.get(`${baseUrl}/transactions/confirm/payment-systems`)
}

export function createTransactionAppeal (id, params) {
  return axios.post(`${baseUrl}/transactions/${id}/appeals`, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
